export default __webpack_public_path__ + "static/ICCAM_05-6cd015e788c122a9d9f527fcc57c4aa5.webp";